import { Button, Flex, Text } from '@radix-ui/themes'
import { Link } from 'react-router-dom'
import { DataTestIDs, RouterPathes } from 'shared/constants'
import { useConsent } from '../hooks/use-consent'
import styles from '../consent.module.scss'

/**
 * Cookie banner (FE-330). Shown until the visitor decides; a policy version
 * bump brings it back. Nothing optional loads before a choice.
 */
export const ConsentBanner = () => {
  const { isDecided, acceptAll, rejectOptional, openDialog } = useConsent()

  if (isDecided) return null

  return (
    <aside
      className={styles.banner}
      role='dialog'
      aria-label='Cookie preferences'
      data-testid={DataTestIDs.consentBanner}
    >
      <Flex
        direction={{ initial: 'column', sm: 'row' }}
        align={{ initial: 'stretch', sm: 'center' }}
        justify='between'
        gap='4'
      >
        <Flex
          direction='column'
          gap='1'
        >
          <Text
            size='3'
            weight='bold'
            className='color-white'
          >
            We use cookies
          </Text>
          <Text
            size='2'
            className='color-gray-light'
          >
            Necessary cookies keep you signed in. Analytics helps us improve the
            games, marketing cookies measure our ads. Details in the{' '}
            <Link
              to={RouterPathes.privacyPolicy}
              className={styles.link}
            >
              privacy policy
            </Link>
            .
          </Text>
        </Flex>

        <Flex
          className={styles.actions}
          gap='2'
          flexShrink='0'
        >
          <Button
            className={styles.actionButton}
            variant='ghost'
            size='3'
            type='button'
            onClick={openDialog}
            data-testid={DataTestIDs.buttonConsentCustomize}
          >
            Customize
          </Button>
          <Button
            className={styles.actionButton}
            variant='soft'
            size='3'
            type='button'
            onClick={rejectOptional}
            data-testid={DataTestIDs.buttonConsentNecessary}
          >
            Only necessary
          </Button>
          <Button
            className={styles.actionButton}
            color='yellow'
            size='3'
            type='button'
            onClick={acceptAll}
            data-testid={DataTestIDs.buttonConsentAcceptAll}
          >
            Accept all
          </Button>
        </Flex>
      </Flex>
    </aside>
  )
}
